<template>
<div class="login">

    <div class="body">
        <div class="wrapper fadeInDown">
            <!-- Form -->
          <form id="formContent" @submit="login">
                 <!--Tabs Titles -->

                <!--Icon -->
                <div class="fadeIn first">
                    <h3 class="pt-3 text-center"> Bienvenido </h3>
                    <p class="text-center">Llena estos datos para crear tu cuenta de usuario <br>
                      <small>Todos los campos son obligatorios</small>
                    </p>
                </div>

                <!--alert Error-->
                <div class="alert alert-success text-center" id="success-alert">
                    <button type="button" class="close" data-dismiss="alert">x</button>
                     <strong>Success! </strong> {{msg_alert}}
                </div>
                
                <!--alert Error-->
                <div class="alert alert-warning text-center" id="warning-alert">
                  <button type="button" class="close" data-dismiss="alert">x</button>
                  <strong>Error! </strong> {{msg_alert}}
                </div>
                
                <!--Login Form -->
                <div class="pt-3">
                    
                    <div class="row wrapperH">
                      <input type="text" class="fadeIn second col-md-5" name="login" placeholder="Nombres" 
                      autocomplete="off" v-model="name" required>
                      
                      <input type="text" class="fadeIn second col-md-5" name="login" placeholder="Apellidos" 
                      autocomplete="off" v-model="apellido" required>
                    </div>

                    <div class="row wrapperH">
                      <input type="text" class="fadeIn second col-md-5" autocomplete="false" 
                      placeholder="Correo Electrónico" v-model="email" required>
                      
                      <input type="text" class="fadeIn second col-md-5"  placeholder="Alias de Usuario" 
                      autocomplete="off" v-model="usuario" required><br>
                    </div>

                    <div class="container">
                      <p>
                        <button type="button" class="btn btn-dark btn-sm" data-toggle="tooltip" data-placement="right" :title="tooltip">
                          ?
                        </button>
                        Requisitos para la contraseña
                      </p>
                    </div>

                    <input type="password" class="fadeIn third" name="login" autocomplete="false" placeholder="Contraseña" v-model="pass" required>
                    <input type="password" class="fadeIn third" name="login" placeholder="Repetir Contraseña" v-model="pass2" required>
                    <div class="pt-2">
                    
                    <div class="container">

                      <p class="px-5 pt-2 text-center">Al acceder o usar la pagina web de nuestros servicios, usted declara que ha leido, entendido y 
                      aceptado estar sujeto a estos terminos:</p>
                      
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="px-5">
                            <input type="checkbox" v-model="checkbox1" class="">
                            <label for="scales"><a :href="urlWeb+ '/assets/pdf/acuerdoUsuario.pdf'"> Acuerdo de Usuario </a></label>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <input type="checkbox" v-model="checkbox2" class="">
                          <label for="scales"><a :href="urlWeb+ '/assets/pdf/codigoConducta.pdf'"> Código de Conducta </a></label>
                        </div>
                      </div>
                    </div>
                    
                    <button v-if="showBoton" type="submit" class="mt-4 fadeIn fourth botonEntrar"> Regístrate </button>
                    <button v-else disabled class="mt-4 fadeIn fourth botonEntrarDisable"> Regístrate </button>
                    </div>
                </div>

                 <!--Remind Passowrd -->
                <div id="formFooter">

                  <div>
                    <p>¿Ya tienes cuenta? 
                      <router-link to="Login" @click="tipoRegistro = 0">Iniciar sesíon</router-link>
                    </p>
                  </div>
                  
                </div>

            </form>
            
        </div>
        
    </div>
    
</div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import $ from 'jquery'

export default {
name: 'Home',
props:['tipoRegistro', 'tipo'],
mixins: [ globalFunctions ],
mounted:function(){
    
    $("#success-alert").hide();
    $("#warning-alert").hide();

    if(this.tipoRegistro==1)
    {
      this.showInputNombre =  true;
      this.showFooterRegistro= true;
      this.opcionRegistro = this.tipo;
    }
    
    $('[data-toggle="tooltip"]').tooltip();
},
data () {
  return {
    showInputNombre: false,
    showFooterInicioSesion: true,
    showFooterRegistro: false,
    name: '',
    apellido: '',
    pass: '',
    pass2: '',
    email: '',
    msg_alert: '',
    opcionRegistro: 0,
    sesion: false,
    usuario: '',
    checkbox1: '',
    checkbox2: '',
    showBoton: false,
    tooltip: 'La clave debe tener al menos 8 caracteres, una letra minuscula, una mayuscula y un valor numérico'
  }
  },
  methods:{

    login(e)
    {
      e.preventDefault();

      this.alert = false;
      this.sesion = false;

      let data = {
          flag: 1,
          nombre: this.name,
          apellido: this.apellido,
          email: this.email,
          pass: this.pass,
          rol: '',
          usuario: this.usuario
      }

      let dataInicio = {
          email: this.email,
          pass: this.pass,
          token: ''
      }

      if(this.pass != this.pass2 ){
        this.msg_alert = 'Las contraseñas no coinciden';
        $("#warning-alert").fadeTo(5000, 500).slideUp(500, function() { 
            $("#success-alert").slideUp(500);
        });
        return;
      }
      
      if(this.opcionRegistro == 2){ //registro empresa
        data.rol = 1;
      } 
      else { //registro consultor
        data.rol = 0;
      }

      this.axios.post(this.url + 'alta_usuario.php', data).then((responce) =>{
          
          if(responce.data == '200'){
            this.inicioSesion(dataInicio);
            this.msjOk2("Gracias por registrarte con nosotros, recibiras por correo informacion importante sobre nuestros servicios");
            this.sendEmail(1,data.email);
          }
          else{
            this.msg_alert = responce.data + ':(';
            $("#warning-alert").fadeTo(5000, 500).slideUp(500, function() { 
                $("#success-alert").slideUp(500);
            });
          }
          
        })
      
    },

    inicioSesion(data){

      this.axios.post(this.url + 'sesion.php', data).then((responce) =>{
          
          if(responce.data.res == '200'){
            localStorage.token = responce.data.token; //atrapamos el token,id y rol desde el servidor y su nombre
            localStorage.userID = responce.data.userID;
            localStorage.rol = responce.data.rol;
            localStorage.tabla = responce.data.tabla;
            //this.$router.push('completaruser');
            this.$router.push('/Perfil');
          }else{
            this.msgerror = true;
          }
        })
    },

    checkAcuerdos(){
        if (this.checkbox1 == true && this.checkbox2 == true){
          this.showBoton = true;
        }else{
          this.showBoton = false;
        }
    }

},
watch:{
  checkbox1(){
    this.checkAcuerdos();
  },
  checkbox2(){
    this.checkAcuerdos();
  }
},
  computed:{
    ...mapState(['url','urlWeb'])
  },
}
</script>

<style scoped>

a {
  color: #92badd;
  display:inline-block;
  text-decoration: none;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  display:inline-block;
  margin: 40px 8px 10px 8px; 
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column; 
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

.wrapperH {
  display: flex;
  align-items: center;
  flex-direction: row; 
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 15px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 800px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* FORM TYPOGRAPHY*/

.botonEntrar{
  background-color: #ff573b;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.botonEntrarDisable{
  background-color: #db5942;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type=text]{
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  margin: 0px 0px 0px 35px;
  font-size: 16px;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}


input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-bottom: 18px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus, input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #ff573b;
}

input[type=text]:placeholder, input[type=password]:placeholder, input[type=email]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after{
  width: 100%;
}

/* OTHERS */

*:focus {
    outline: none;
} 

#icon {
  width:60%;
}


</style>>




// WEBPACK FOOTER //
// src/components/Subregistro.vue